import type { JSX } from 'react';
import { useEffect, useState } from 'react';

import { cn } from '@change/ds-utils';

import { useTracking } from '@change-corgi/core/react/tracking';

import { PRE_MADE_POST_MODAL_COMMON_PROPERTIES } from '../../hooks/useSharePreviewModal';
import { LoadingMessage } from '../LoadingMessage';
import { ZoomButton } from '../ZoomButton';

import { YourPost } from './YourPost';

export const PRE_MADE_POST_MODAL_EXPAND_CLICK_EVENT_NAME = 'expand_facebook_share_post';

type PostPreviewProps = {
	isLoading?: boolean;
	postText?: string;
	imageUrl?: string | null;
	previewTitle?: string;
};

export function PostPreview({ isLoading = false, postText, imageUrl, previewTitle }: PostPreviewProps): JSX.Element {
	const [isExpanded, setIsExpanded] = useState(false);
	const track = useTracking();

	useEffect(() => {
		if (isExpanded) {
			void track(PRE_MADE_POST_MODAL_EXPAND_CLICK_EVENT_NAME, PRE_MADE_POST_MODAL_COMMON_PROPERTIES);
		}
	}, [isExpanded, track]);

	return (
		<div
			className={cn('grow-1 relative flex flex-col items-center justify-center rounded-2xl bg-background-overlay p-4', {
				'h-[180%]': isExpanded,
				'h-[100%]': !isExpanded,
			})}
		>
			{isLoading && <LoadingMessage />}
			{!isLoading && (
				<>
					<ZoomButton onClick={() => setIsExpanded((prev) => !prev)} />
					<YourPost isExpanded={isExpanded} postText={postText} imageUrl={imageUrl} previewTitle={previewTitle} />
				</>
			)}
		</div>
	);
}
